import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { Tabs as AntdTabs, TabsProps as AntdTabsProps, TabPaneProps, Badge } from 'antd';

import './styles.less';

const { TabPane } = AntdTabs;

export default function Tabs({
  tabs,
  size = 'large',
  children,
  pushToHistory = true,
  defaultActiveKey: baseDefaultActiveKey,
  activeKey,
  className = 'tw-relative',
  shareQueryParams = false,
  ...rest
}: TabsProps): JSX.Element {
  const { url } = useRouteMatch();
  const history = useHistory();

  if (pushToHistory) {
    [, activeKey = baseDefaultActiveKey] = window.location.pathname.match(/.+\/(.+)$/) || [];
    if (!tabs.find(({ to }) => activeKey === to)?.to) {
      const tab = tabs.find(
        ({ to }, idx) => !!children[idx] && window.location.pathname.split('/').includes(to)
      );

      activeKey = tab?.to || tabs.find((_, idx) => !!children[idx])!.to;
    }
  }

  return (
    <AntdTabs
      size={size}
      onChange={path => {
        if (pushToHistory)
          history.push(`${url}/${path}${shareQueryParams ? window.location.search : ''}`);
      }}
      defaultActiveKey={baseDefaultActiveKey}
      {...(pushToHistory && {
        defaultActiveKey: baseDefaultActiveKey || activeKey,
      })}
      activeKey={activeKey}
      className={className}
      {...rest}
    >
      {tabs.map(
        ({ to, label, labelClassName, badge, className, ...rest }, idx) =>
          children[idx] && (
            <TabPane
              className={className}
              key={to}
              tab={
                <div className={`${labelClassName} tw-mb-0`}>
                  {label}
                  {badge && (
                    <Badge
                      size="small"
                      className="tw-bg-primary tw-text-white tw-ml-3 tw-text-xs tw-px-2 tw-rounded-xs"
                    >
                      {badge}
                    </Badge>
                  )}
                </div>
              }
              {...rest}
            >
              {children[idx]}
            </TabPane>
          )
      )}
    </AntdTabs>
  );
}
export interface Tab extends TabPaneProps {
  to: string;
  label: React.ReactNode;
  badge?: string;
  [key: string]: unknown;
}
export interface TabsProps extends AntdTabsProps {
  tabs: Array<Tab>;
  children: Array<React.ReactNode>;
  pushToHistory?: boolean;
  shareQueryParams?: boolean;
}
